<ion-content [fullscreen]="true" *transloco="let t; read: 'loginPage'">
    <ion-grid class="grid">
        <div class="login-wrapper">
            <div class="wrap">




                <div class="wrapper-header">

                    <div class="language-switcher">

                        <app-language-switcher [showListStyle]="true" ></app-language-switcher>
                    </div>

                    <div class="arrow-back" *ngIf="createNewStudent" (click)="refresh()">

                        <svg fill="#D7F3C2" height="39px" width="39px" version="1.1" id="Layer_1"
                             xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                             viewBox="0 0 476.213 476.213" xml:space="preserve" stroke="#D7F3C2"><g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                            <g id="SVGRepo_iconCarrier"> <polygon
                                points="476.213,223.107 57.427,223.107 151.82,128.713 130.607,107.5 0,238.106 130.607,368.714 151.82,347.5 57.427,253.107 476.213,253.107 "></polygon> </g></svg>
                    </div>

                    <a [routerLink]="'/login'">
                        <img class="login-logo" src="assets/images/icons/login-logo.svg" alt="login logo">
                    </a>
                </div>
                <div class="login-form" *ngIf="!authorized">
                    <form class="login">
                        <div class="login-form-header" *ngIf="!createNewStudent">
                            <h4 class="login-form-title">
                                {{ t('title') }}
                            </h4>
                        </div>
                        <div class="login-form-header new-student" *ngIf="createNewStudent">
                            <h4 class="login-form-title">
                                {{ t('register')  }}
                            </h4>

                            <div class="teaser" [innerHTML]="t('registerTeaser')"></div>

                            <div class="teaser" [innerHTML]="t('registerTeaser1')"></div>
                        </div>

                        <div class="login-form-content" #telInputBlock>

                            <intl-tel-input
                                #telInputElement
                                [name]="'phone'"
                                [cssClass]="'form-group-control phone'"
                                [labelCssClass]="'col-sm-2 col-form-label'"
                                [required]="true"
                                [options]="{
                    preferredCountries: ['ua'],
                    initialCountry:'ua',
                    separateDialCode:true
                  }"
                                [(E164PhoneNumber)]="phone"
                                (input)="isEnterNumberIsDeleted = false; goRegister=false"

                            ></intl-tel-input>

                            <small class="error-message"
                                   *ngIf="this.isEnterNumberIsDeleted">
                                {{ t('errorAlreadyExist')}}
                            </small>

                            <small class="error-message"
                                   *ngIf="this.goRegister">
                                {{ t('errorNotExist')}}
                            </small>

                            <div *ngIf="!createNewStudent">
                                <button type="button" class="btn btn-green" (click)="doLogin()" [disabled]="isEnterNumberIsDeleted ||this.goRegister"
                                        [ngClass]="{'disable' : this.isEnterNumberIsDeleted ||this.goRegister}" > {{ t('login') }}</button>
                                <button type="button" class="btn register-btn"
                                        (click)="createNewStudent = true; goRegister=false;"
                                        [disabled]="isEnterNumberIsDeleted"
                                        [ngClass]="{'disable' : this.isEnterNumberIsDeleted}"> {{ t('registration') }}
                                </button>
                            </div>

                            <button type="button" class="btn btn-green" *ngIf="createNewStudent" [disabled]="isEnterNumberIsDeleted || this.goRegister||  !this.phone"
                                    [ngClass]="{'disable' : this.isEnterNumberIsDeleted ||this.goRegister || !this.phone}"  (click)="goToRegister()"> {{ t('continue') }}
                            </button>


                        </div>
                    </form>

                    <div class="login-video-wrapper">

                        <iframe class="embed-responsive-item" width="100%" height="100%"
                                src="https://www.youtube.com/embed/6biKQlyosL0" allow="autoplay; encrypted-media"
                                allowfullscreen></iframe>

                    </div>

                </div>


                <div class="login-form profile-form" *ngIf="authorized">
                    <div class="login login-form-content ">
                        <button type="button" class="btn btn-green"
                                (click)="goToParentDashboard()">{{ t('parentCabinet') }}
                        </button>
                        <button type="button" class="btn btn-green"
                                (click)="showChildrenDropdown =!showChildrenDropdown"
                                [ngClass]="{'open-profile' :showChildrenDropdown}">
                            {{ t('childCabinet') }}

                            <img [ngClass]="{'rotate-180':showChildrenDropdown}"
                                 [src]="'assets/images/icons/arrow_down_white.svg'"/>

                        </button>

                        <div class="child-profile-wrapper" *ngIf="showChildrenDropdown">
                            <div *ngFor="let child of children;"
                                 class="ion-padding ion-margin-top ion-margin-bottom child-profile">

                                <ion-row class="ion-align-items-center">
                                    <ion-col class="avatar-container" size="auto">
                                        <ion-avatar class="avatar" *ngIf="!this.child?.avatar">
                                            <img alt="child profile"
                                                 src="assets/images/child/{{child.gender === 1?'boy.png':'girl.png' }}"
                                                 width="52px"/>
                                        </ion-avatar>


<!--                                        <ion-avatar *ngIf="this.child?.avatar" class="avatar" [ngStyle]="{'background-image': 'url(' + this.child?.avatar + ')'}">-->
<!--                                        </ion-avatar>-->
                                        <ion-avatar class="avatar student" *ngIf="this.child?.avatar">
                                            <img alt="child profile"
                                                 src="{{this.child?.avatar}}"
                                                 width="52px"/>
                                        </ion-avatar>


                                    </ion-col>

                                    <ion-col class="info" size="auto" size-md="5" size-xs="5" size-sm="5" size-xl="auto"
                                             size-lg="auto">
                                        <div class="name">
                                            {{ child.name }} <br>
                                            {{ child.last_name }}
                                        </div>
                                    </ion-col>
                                    <ion-col></ion-col>

                                    <ion-col size="auto">
                                        <button type="button" class="btn dark-btn"
                                                (click)="goToChildDashboard(child)">{{ t('login') }}
                                        </button>
                                    </ion-col>

                                </ion-row>


                            </div>
                        </div>


<!--                        <div class="info-cabinet" (click)="showMoreInfoCabinet = !showMoreInfoCabinet">-->
<!--                            <img-->
<!--                                src="assets/images/icons/question_dark.svg"-->
<!--                                (click)="checkCabinetInfo = !checkCabinetInfo"-->
<!--                                alt="add">-->
<!--                            {{ t('cabinetInfo') }}-->
<!--                            <div class="arrow" [ngClass]="{'up': showMoreInfoCabinet }"></div>-->
<!--                        </div> -->

                        <div class="info-cabinet" (click)="openModal()">
                            <img
                                src="assets/images/icons/question_dark.svg"
                                (click)="checkCabinetInfo = !checkCabinetInfo"
                                alt="add">
                            {{ t('cabinetInfo') }}
                        </div>

<!--                        <div class="info-cabinet-wrapper" *ngIf="showMoreInfoCabinet">-->
<!--                            <img src="assets/images/cabinet_info.png">-->


<!--                        </div>-->
                    </div>
                </div>

                <div class="contact-use" *ngIf="authorized && window.innerWidth>767" [innerHTML]="t('contactUs')" >

                </div>
                <div class="contact-use" *ngIf="authorized && window.innerWidth<767" [innerHTML]="t('contactUsSmall')">

                </div>


                <div class="wrap-links" *ngIf="!authorized && !hideStoreLinks">
                    <a class="store-link-item" href="https://apps.apple.com/us/app/green-country/id1356426734"
                       target="_blank">
                        <img src="assets/images/icons/appstore.svg" alt="appstore">
                    </a>
                    <a class="store-link-item"
                       href="https://play.google.com/store/apps/details?id=ua.com.greencountry.my"
                       target="_blank">
                        <img src="assets/images/icons/googleplay.svg" alt="googleplay">
                    </a>
                </div>



            </div>

        </div>

    </ion-grid>

    <app-footer></app-footer>

</ion-content>

<app-chats></app-chats>
